
import styled from 'styled-components';
import { colors } from '@/common/styled-variables';

export const SimpleAlert = styled.p`
    color: ${colors.red};
    margin: 0;
    padding: 4px 0 8px 0;
`;
